export type { IStripeService } from './stripe-service';
export type { ISubscriptionsState } from './state';
export * from './components';

import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { IStripeService, stripe_service_provider } from './stripe-service';
import { ISubscriptionsState, subscriptions_state_provider } from './state';
import { show_pro_feature_modal_factory } from './use-cases/show-pro-feature-modal';
import { show_view_only_modal_factory } from './use-cases/show-view-only-modal';
import { show_select_a_subscription_page_factory } from './use-cases/show-select-a-subscription-page';

export type ISubscriptions = {
    state: ISubscriptionsState;
    stripe: IStripeService;
    show_pro_feature_modal: ReturnType<typeof show_pro_feature_modal_factory>;
    show_view_only_modal: ReturnType<typeof show_view_only_modal_factory>;
    show_select_a_subscription_page: ReturnType<typeof show_select_a_subscription_page_factory>;
};

export const subscriptions_provider = (app: IFrontendServiceContainer): ISubscriptions => {
    const state = subscriptions_state_provider(app.device_storage);
    const stripe = stripe_service_provider(app.api.helper);
    const show_pro_feature_modal = show_pro_feature_modal_factory(state);
    const show_view_only_modal = show_view_only_modal_factory(state);
    const show_select_a_subscription_page = show_select_a_subscription_page_factory(app);

    return {
        state,
        stripe,
        show_pro_feature_modal,
        show_view_only_modal,
        show_select_a_subscription_page,
    };
};
